module.exports = __webpack_public_path__ + "static/media/icon-modelo-anamnese.b995aeaf.png";